export { default } from './VerticalCollapsedItem';
